import PurchasedCustomPrintConfigNotice from './PurchasedCustomPrintConfigNotice';

export default PurchasedCustomPrintConfigNotice;
